module.exports = __webpack_public_path__ + "img/storo-storsenter-logo.b914d30d.svg";